export function fixImageUrl(url?: string) {
  if (!url) return url;

  try {
    // if it's already local (assets/ or /assets/), keep it
    if (url.startsWith("assets/") || url.startsWith("/assets/")) return url;

    const u = new URL(url);

    if (u.hostname === "assets.hottel.io") {
      return `/img-hottel${u.pathname}${u.search}`;
    }

    if (u.hostname === "image.tmdb.org") {
      return `/img-tmdb${u.pathname}${u.search}`;
    }

    if (u.hostname === "assets.innplay.cloud") {
      return `/img-innplay${u.pathname}${u.search}`;
    }

    return url;
  } catch {
    // If URL is not absolute, just return it
    return url;
  }
}
